import { z } from 'zod';
import { reportingTrainingTeamSummaryCapability } from './reporting-definition.contract.js';
export const reportingTrainingTeamSummarySlot = 'reporting.training-team-summary';
export const reportingTrainingTeamSummaryProviderId = 'training.server.reporting-team-summary';
export const reportingTrainingTeamSummaryProviderCapability = 'training.reporting-team-summary.v1';
const countSchema = z.number().int().nonnegative().safe();
const nullableTimestampSchema = z.string().datetime({ offset: true }).nullable();
export const reportingTrainingTeamSummaryRequestSchema = z.strictObject({
    consumerModuleId: z.literal('reporting'),
    requestedCapability: z.literal(reportingTrainingTeamSummaryCapability),
    resourceType: z.literal('reporting.dataset'),
    resourceId: z.string().uuid(),
    membershipIds: z.array(z.string().uuid()).min(1).max(500),
    asOf: z.string().datetime({ offset: true }),
});
export const reportingTrainingTeamSummaryFactSchema = z.strictObject({
    membershipId: z.string().uuid(),
    assignmentTotal: countSchema,
    assignmentOpen: countSchema,
    assignmentCompleted: countSchema,
    assignmentWaived: countSchema,
    assignmentOverdue: countSchema,
    completedCourseCount: countSchema,
    assessmentAttemptCount: countSchema,
    assessmentPassedCount: countSchema,
    averageScoreBasisPoints: z.number().int().min(0).max(10_000).nullable(),
    latestAssessmentSubmittedAt: nullableTimestampSchema,
    activitySessionCount: countSchema,
    activityActiveSeconds: countSchema,
    latestActivityAt: nullableTimestampSchema,
}).superRefine((fact, context) => {
    if (fact.assignmentTotal !==
        fact.assignmentOpen + fact.assignmentCompleted + fact.assignmentWaived ||
        fact.assignmentOverdue > fact.assignmentOpen ||
        fact.assessmentPassedCount > fact.assessmentAttemptCount) {
        context.addIssue({ code: 'custom', message: 'Training report counts do not reconcile.' });
    }
    const hasAssessments = fact.assessmentAttemptCount > 0;
    const hasActivity = fact.activitySessionCount > 0;
    if (hasAssessments !== (fact.averageScoreBasisPoints !== null) ||
        hasAssessments !== (fact.latestAssessmentSubmittedAt !== null) ||
        hasActivity !== (fact.latestActivityAt !== null)) {
        context.addIssue({ code: 'custom', message: 'Training report missing state is inconsistent.' });
    }
});
export const reportingTrainingTeamSummaryProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(reportingTrainingTeamSummaryProviderCapability),
    tenantId: z.string().uuid(),
    asOf: z.string().datetime({ offset: true }),
    activityBasis: z.literal('supporting-training-activity'),
    payableTime: z.literal(false),
    memberships: z.array(reportingTrainingTeamSummaryFactSchema).min(1).max(500),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
});
export const reportingTrainingTeamSummaryRowSchema = reportingTrainingTeamSummaryFactSchema
    .safeExtend({ membershipDisplayName: z.string().trim().min(1).max(240) });
export const reportingTrainingTeamSummaryTotalsSchema = z.strictObject({
    assignmentTotal: countSchema,
    assignmentOpen: countSchema,
    assignmentCompleted: countSchema,
    assignmentWaived: countSchema,
    assignmentOverdue: countSchema,
    completedCourseCount: countSchema,
    assessmentAttemptCount: countSchema,
    assessmentPassedCount: countSchema,
    activitySessionCount: countSchema,
    activityActiveSeconds: countSchema,
});
//# sourceMappingURL=reporting-training-team-summary.contract.js.map